import "./pageHeader.scss";

type Tab = {
    key?: string;
    label: React.ReactNode;
    count?: number;
    warn?: boolean;
    active: boolean;
    onClick: () => void;
};

type RosterSubBarProps = {
    tabs?: Tab[];
    subRightActions?: React.ReactNode;
    accentColor?: string;
    loading?: boolean;
};

// This bar's sticky `top` comes from the --sticky-header-h custom property (see
// pageHeader.scss) rather than a hardcoded 0 — PageHeader sets that variable to its own
// live measured height on their shared parent. Plain CSS sticky-sibling stacking (this bar
// and the header both `position: sticky; top: 0`) does NOT reliably avoid overlapping the
// header; it only happens to look right when a page's content leaves a big enough scroll
// gap between them, which isn't guaranteed (confirmed broken on real data).
export default function RosterSubBar({ tabs, subRightActions, accentColor, loading }: RosterSubBarProps) {
    if (!tabs?.length && !subRightActions) return null;

    const accentStyle = accentColor ? ({ "--ph-accent": accentColor } as React.CSSProperties) : undefined;

    return (
        <div className="page-header__sub page-header__sub--sticky" style={accentStyle}>
            <div className="page-header__tabs-scroller">
                {tabs && (
                    <div className="page-header__tabs">
                        {tabs.map((tab, i) => (
                            <button
                                key={tab.key ?? i}
                                className={[
                                    "page-header__tab",
                                    tab.active ? "page-header__tab--active" : "",
                                    tab.warn ? "page-header__tab--warn" : "",
                                ].filter(Boolean).join(" ")}
                                onClick={tab.onClick}
                            >
                                {tab.label}
                                {tab.count !== undefined && (
                                    loading
                                        ? <span className="page-header__tab-count page-header__tab-count--loading" />
                                        : <span className="page-header__tab-count">{tab.count}</span>
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
            {subRightActions && (
                <div className="page-header__sub-right">{subRightActions}</div>
            )}
        </div>
    );
}
